module.exports = __webpack_public_path__ + "static/Scribd-f649d6883f0ab7fe695d58207e337bd4.png";